import { FormErrors } from 'redux-form';
// @ts-ignore
import MESSAGES from 'constants/messages';
// @ts-ignore
import isEmail from 'validator/lib/isEmail';

interface Errors {
  email?: string;
}

export default ({ email }: Errors): FormErrors<Errors> => {
  const errors: FormErrors<Errors> = {};

  if (!email) {
    errors.email = MESSAGES.FORGOT_PASSWORD.EMAIL.REQUIRED;
  }

  if (email && !isEmail(email)) {
    errors.email = MESSAGES.FORGOT_PASSWORD.EMAIL.VALID;
  }

  return errors;
};
